/** Shared dashboard filter helpers (DashboardContext, TopBar, HomeScreen). */

/** Months API returns DESC order — first entry is latest. */
export function getLatestMonth(months) {
  if (!Array.isArray(months) || months.length === 0) return null;
  return months[0];
}

/** BigQuery aggregates with no matching rows still return NULL → API coerces to 0. */
export function isEmptyKpiResponse(kpis) {
  if (!kpis || Object.keys(kpis).length === 0) return true;
  const customers = kpis.customer_count ?? 0;
  const sales = kpis.total_sales ?? 0;
  const newCount = kpis.new_customer_count ?? 0;
  const repeatCount = kpis.repeat_customer_count ?? 0;
  return customers === 0 && sales === 0 && newCount === 0 && repeatCount === 0;
}

export function normalizeKpis(kpis) {
  if (isEmptyKpiResponse(kpis)) return null;
  return kpis;
}

/**
 * True when `stylist` is the signed-in user's own POS record.
 * Reuses matchStylistForUser so a display name without the store suffix
 * (井上花音 vs 井上花音【立川】) still resolves to the same person.
 */
export function isOwnStylist(displayName, stylist) {
  if (!displayName || !stylist) return false;
  return matchStylistForUser(displayName, [stylist]) === stylist;
}

/** Match Firebase displayName to a stylist in the store roster. */
export function matchStylistForUser(displayName, stylists) {
  const name = displayName?.trim();
  if (!name || !Array.isArray(stylists) || stylists.length === 0) return null;
  const exact = stylists.find((s) => s === name);
  if (exact) return exact;
  const partial = stylists.find((s) => s.includes(name) || name.includes(s));
  return partial || null;
}

/** Easy POS-name match (full-width, spaces). Not NLP. */
export function normalizePosName(s) {
  return String(s || '')
    .normalize('NFKC')
    .replace(/\s/g, '')
    .toLowerCase();
}

export function filterPosNames(query, names) {
  const q = normalizePosName(query);
  if (!q || !Array.isArray(names)) return [];
  return names.filter((n) => normalizePosName(n).includes(q));
}

/** Same predicate GoalEdit uses for first-run (KGI + period). */
export function hasSavedKgi(goals) {
  return (
    (goals?.salesTarget ?? goals?.finalSales ?? null) != null &&
    (goals?.planLength != null || goals?.goalDate != null)
  );
}
